import React, { useState } from 'react';
import { ChromePicker } from 'react-color';
import ChartOverlay from './ChartOverlay';

export default function CastColor({ colors, updateColors }: {
    colors: string[]; updateColors: (colors: string[]) => void;
}) {
    const [selected, setSelected] = useState<number | null>(null);
    return <>
        <div role="group" aria-label="Lane colors" className="flex items-center gap-1 shrink-0">
            {[3, 1, 0, 2, 4].map(castIndex => {
                const label = ['1st', '2nd', '3rd', '4th', '5th'][castIndex];
                return <button key={castIndex} type="button" aria-label={`Change ${label} lane color`} aria-expanded={selected === castIndex}
                        aria-haspopup="dialog"
                        className="w-5 h-5 rounded border border-gray-300 shadow-sm cursor-pointer"
                        style={{ backgroundColor: colors[castIndex] }}
                        onClick={() => setSelected(selected === castIndex ? null : castIndex)} />;
            })}
        </div>
        <ChartOverlay open={selected !== null} title="Lane color" onClose={() => setSelected(null)}>
        {selected !== null && <div className="flex justify-center p-4">
            <ChromePicker disableAlpha color={colors[selected]} onChangeComplete={color => {
                const next = [...colors];
                next[selected] = `rgb(${color.rgb.r},${color.rgb.g},${color.rgb.b})`;
                updateColors(next);
            }} />
        </div>}
        </ChartOverlay>
    </>;
}
